export const convertStringToBoolean = (value: '0' | '1'): boolean => value === '1'
export const convertBooleanToNumber = (value: boolean): 0 | 1 => (value ? 1 : 0)
